import TextInput from '@/components/refinedev/TextInput';
import {UseDialogStateReturn} from '@/hooks/useDialogState';
import {FormProvider, useForm, UseFormProps} from 'react-hook-form';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
  DialogOverlay,
} from '@/shadcn_components/ui/dialog';
import {Node, useReactFlow} from '@xyflow/react';
import {SaveButton} from '@/components/refinedev/action_buttons';
import {ReactNode, useCallback} from 'react';
import {newNode} from './nodes/utils';
import {dirtyValues} from '@/lib/react-hook-form-helpers';
import useWorkflowStore from './store';
import { FlowNode } from './utils/types';

export type NodeEditDialogProps = {
  title?: string;
  children?: ReactNode;
  dialogState: UseDialogStateReturn;
  onSubmit?: (data: any) => Promise<void>;
  closeWhenSubmit?: boolean;
  submitDirtyFieldsOnly?: boolean;
  transformBeforeSave?: (data: any) => any;
  formProps?: UseFormProps<any>;
  onSuccess?: (node: FlowNode) => void;
  // onError?: (error: any) => void;
};

export const NodeEditDialog = (props: NodeEditDialogProps) => {
  const {
    submitDirtyFieldsOnly,
    dialogState,
    formProps,
    title,
    children,
    onSubmit,
    closeWhenSubmit = true,
    onSuccess
  } = props;
  const {id: node_id, data} = dialogState.extraData || {};

  const {updateNodeData} = useReactFlow();

  const form = useForm({...formProps, defaultValues: data});
  const {
    handleSubmit,
    formState: {dirtyFields},
  } = form;

  const onSubmitDefault = useCallback(
    async submittedData => {
      const inputData = submitDirtyFieldsOnly
        ? dirtyValues(dirtyFields, submittedData)
        : submittedData;
      const data = props.transformBeforeSave?.(inputData) || inputData;

      const nodeData = newNode({
        type: dialogState.extraData.type,
        position: dialogState.extraData.position,
        data, // clone data
      });

      if (!onSubmit) {
        console.log('submitted', nodeData);
        if (node_id) {
          updateNodeData(node_id, data);
        }
      } else {
        await onSubmit?.(nodeData);
      }

      // on success
      if (onSuccess){
        setTimeout(() => {
          onSuccess?.(nodeData);
        }, 0);   
      }
      if (closeWhenSubmit) dialogState.closeDialog();
    },
    [onSubmit, dialogState, closeWhenSubmit, updateNodeData, node_id, dirtyFields],
  );

  function onOpenChange(open) {
    console.log('dialog open', open);
    if (!open) form.reset();
    dialogState.setOpen(open);
  }

  return (
    <Dialog open={dialogState.open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmitDefault)}>
            <DialogHeader>
              <DialogTitle>{title}</DialogTitle>
              <DialogDescription></DialogDescription>
            </DialogHeader>
            <div className="my-2 overflow-y-auto max-h-[calc(100vh-200px)] scroll px-2">
              {children}
            </div>
            <DialogFooter>
              <SaveButton type="button" onClick={handleSubmit(onSubmitDefault)} />
            </DialogFooter>
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
};
